import { useEffect } from "react";
import { useSnackbar } from "notistack";

import { useStackSnackbarStore } from "../../hooks/useStackSnackbarStore";
import CustomeSnackbar from "./CustomSnackbar";

const StackSnackbarManager = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { queue, dequeue } = useStackSnackbarStore();

  useEffect(() => {
    if (queue.length === 0) return;

    const { message, type = "success" } = queue[0];

    enqueueSnackbar(message, {
      autoHideDuration: 3000,
      persist: false,
      content: (_key, msg) => (
        <CustomeSnackbar message={msg as string} type={type} />
      ),
    });

    dequeue();
  }, [queue, enqueueSnackbar, dequeue]);

  return null;
};

export default StackSnackbarManager;
